import React from "react";
import pluralize from "pluralize";

import { City } from "@/custom-types/CitiesNearMe";

export type CityCardProps = {
  cityData: City;
};

const CityCard = ({
  cityData: { city, count, distance, distanceUnit, path, state },
}: CityCardProps) => {
  return (
    <a href={path}>
      <div className="bg-white p-sm rounded shadow-low">
        <div className="font-bold text-xs">{`${city}, ${state}`}</div>
        <div className="text-xs">{`${distance.toFixed(1)} ${distanceUnit}`}</div>
        <div className="text-xs">{`${count} ${pluralize("dispensary", count)}`}</div>
      </div>
    </a>
  );
};

export default CityCard;
